"use client"

import { useEffect } from "react"
import { useTracking } from "@/app/contexts/tracking-context"

interface Props {
    strategicPage?: boolean
    parents?: string[]
}

// GTM forwards these keys with the GA4 page_view and every funnel event
export default function PageCoconTracker({ strategicPage, parents }: Props) {
    const { track } = useTracking()

    useEffect(() => {
        const pathSegments = window.location.pathname.split("/").filter(Boolean)

        track({
            pageStrategique: strategicPage || false,
            pageCocon: "/" + pathSegments.slice(0, 2).join("/"),
            pageCocons: parents,
        })
    }, [strategicPage, parents, track])

    return null
}
